export { default } from './HeldCopiesCount';



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/HeldCopiesCount/index.js